import mapboxgl from 'mapbox-gl';

window.mapboxgl = mapboxgl;
export default mapboxgl;
